import type { CoverageTone } from './coverageFormat';

/**
 * Semantic ink for the coverage tile, kept apart from the dashboard's brand
 * ramp: tone has to read as a state at a glance, independently of the accent.
 */
export interface ToneTokens {
  readonly ink: string;
  readonly surface: string;
}

const LIGHT: Record<CoverageTone, ToneTokens> = {
  positive: { ink: '#1f8a56', surface: 'rgba(31, 138, 86, 0.12)' },
  caution: { ink: '#b7791f', surface: 'rgba(183, 121, 31, 0.14)' },
  critical: { ink: '#c0392b', surface: 'rgba(192, 57, 43, 0.12)' },
  neutral: { ink: '#5c6b85', surface: 'rgba(92, 107, 133, 0.12)' },
};

const DARK: Record<CoverageTone, ToneTokens> = {
  positive: { ink: '#62c396', surface: 'rgba(98, 195, 150, 0.16)' },
  caution: { ink: '#dcac53', surface: 'rgba(220, 172, 83, 0.16)' },
  critical: { ink: '#ee8a7c', surface: 'rgba(238, 138, 124, 0.16)' },
  neutral: { ink: '#9aa6ba', surface: 'rgba(154, 166, 186, 0.16)' },
};

export const getToneTokens = (tone: CoverageTone, mode?: string): ToneTokens =>
  (mode === 'dark' ? DARK : LIGHT)[tone] ?? LIGHT.neutral;
